import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { queryClient, useTRPC } from "../api.ts";
import { mensajeDe } from "../utiles.ts";

/**
 * Abre la hoja de hoy de un formato (o una más, con `otra`) y lleva a llenarla. Lo usan la lista
 * de hojas del documento y las tarjetas de Diligencias; el error se muestra donde se pidió.
 */
export function useAbrirHoja(onError: (mensaje: string) => void) {
  const trpc = useTRPC();
  const navigate = useNavigate();
  return useMutation(
    trpc.hojas.abrir.mutationOptions({
      onSuccess: (r) => {
        queryClient.invalidateQueries();
        navigate({ to: "/hojas/$id", params: { id: r.id } });
      },
      onError: (e) => onError(mensajeDe(e)),
    }),
  );
}
